import { useState } from "react";
import "./works.scss";

export default function Works() {

    const [currentSlide, setCurrentSlide] = useState(0);
    const data = [
        {
            id: "1",
            icon: "./assets/Affinity.png",
            title: "Affinity Devs",
            desc:
                "Affinity Devs portfolio site made with React+Vite+Tailwindcss+three.js",
            img:
                "https://99designs-blog.imgix.net/blog/wp-content/uploads/2018/10/attachment_100040756-e1538485934255.jpeg?auto=format&q=60&fit=max&w=930",
            image: "./assets/Affinity_ss.png",
            link: "http://affinitydevs.com",

        },
        {
            id: "2",
            icon: "./assets/nike.png",
            title: "Nike",
            desc:
                "Nike landing page made using React+Tailwindcss",
            img:
                "https://i.pinimg.com/originals/e9/c9/2f/e9c92f7869d682a6fa5a97fb8a298f30.jpg",
            image: "./assets/nike_ss.png",
            link: "http://nike-h.vercel.app",
        },
        {
            id: "3",
            icon: "./assets/writing.png",
            title: "Property-Pulse",
            desc:
                "Real Estate app that give user updates about properties using Rapid API. Made using Next JS, React JS, Chakra UI and Rapid API.",
            img:
                "https://i.pinimg.com/originals/a9/f6/94/a9f69465d972a004ad581f245d6ad581.jpg",
            image: "./assets/real-estate.png",
            link: "https://property-pulsee.vercel.app",
        },
        {
            id: "4",
            icon: "./assets/writing.png",
            title: "Shoping-Mart",
            desc:
                "Made using React JS + Typescript",
            img:
                "https://i.pinimg.com/originals/a9/f6/94/a9f69465d972a004ad581f245d6ad581.jpg",
            image: "./assets/shoping-mart.png",
            link: "https://my-shoping-mart.vercel.app",
        },
        {
            id: "5",
            icon: "./assets/writing.png",
            title: "Music Player",
            desc:
                "Made with HTML, CSS and JavaScript",
            img:
                "https://i.pinimg.com/originals/a9/f6/94/a9f69465d972a004ad581f245d6ad581.jpg",
            image: "./assets/music-player.png",
            link: "https://tunes-note.vercel.app",
        },

    ]; 

    const handleClick = (way) => {
        way === "left"
            ? setCurrentSlide(currentSlide > 0 ? currentSlide - 1 : 2)
            : setCurrentSlide(currentSlide < data.length - 1 ? currentSlide + 1 : 0);
    };

    return (
        <>
            <div className="works" id="works">

                <div
                    className="slider"
                    style={{ transform: `translateX(-${currentSlide * 100}vw)` }}
                >

                    {data.map((d) => (
                        <div className="container">
                            <div className="item">
                                <div className="left">
                                    <div className="leftContainer">
                                        <div className="imgContainer">
                                            <img src={d.icon} alt="" />
                                        </div>
                                        <h2>{d.title}</h2>
                                        <p>{d.desc}</p>
                                        {/* <span>Projects</span> */}
                                        <a href={d.link} target="_blank" rel="noopener noreferrer">
                                            <button >Open</button>

                                        </a>
                                    </div>
                                </div>
                                <div className="right">
                                    <img

                                        src={d.image}
                                        alt=""

                                    />
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                <img
                    src="assets/arrow.png"
                    className="arrow left"
                    alt=""
                    onClick={() => handleClick("left")}
                />
                <img
                    src="assets/arrow.png"
                    className="arrow right"
                    alt=""
                    onClick={() => handleClick()}
                />
            </div>
        </>
    );
}
